// 外勤版（pc-hasl-agent）：仅保留个人首页、轨迹、电子执业证、收入、三要素鉴权、保单查询、
// 消息中心、资讯、资讯详情、团队继续率、个人继续率、孤儿单接收 所需接口

export default {
  // 用户/菜单/组织
  getPuserInfo: '/api/v1/ext/agent/performance/getUserBaseInfo',
  getUserRoles: '/api/v1/ext/agent/performance/getUserRoles', // 权限-查询角色权限
  getTeamTree: '/api/v1/ext/agent/performance/getTeamtree',
  // 首页天气
  getWeather: '/api/v1/ext/agent/activity/getTemp',
  // 消息中心
  getAllType: '/api/v1/ext/cms/message/getAllType',
  getMessage: '/api/v1/ext/cms/message/getMessage',
  clear: '/api/v1/ext/cms/message/clear',
  tabRead: '/api/v1/ext/cms/message/tabRead',
  tabAllRead: '/api/v1/ext/cms/message/tabAllRead',
  // 资讯
  initInformation: '/api/v1/ext/cms/content/initInformation', // 资讯公司新闻
  initChannelInfo: '/api/v1/ext/cms/content/initChannelInfo', // 资讯渠道新闻
  getContent: '/api/v1/ext/cms/content/getContent', // 获取详情
  // 轨迹/电子执业证/收入
  trajectory: '/api/v1/ext/agent/performance/getTrajectory',
  getCertificates: '/api/v1/ext/agent/performance/getCertificates',
  // 个人继续率
  getPersonalConRate: '/api/v1/ext/agent/performance/getPersonalConRate',
  getPersonalConRateDetail: '/api/v1/ext/agent/performance/getPersonalConRateDetail',
  exportExcel: '/api/v1/ext/agent/performance/exportExcel',
  // 团队继续率
  getTeamConRate: '/api/v1/ext/agent/performance/getTeamConRate',
  // 孤儿单接收
  getOrphanPolicy: '/api/v1/ext/agent/orphan/getOrphanPolicy',
  getOrphanPolicyInfo: '/api/v1/ext/agent/orphan/getOrphanPolicyInfo',
  handleOrphanPolicy: '/api/v1/ext/agent/orphan/handleOrphanPolicy',
  // 三要素鉴权
  checkThreeElementByFile: '/api/v1/ext/agent/customer/checkThreeElementByFile', // 文件三要素鉴权
  getThreeElementVerifyHis: '/api/v1/ext/agent/customer/getThreeElementVerifyHis', // 文件三要素鉴权操作轨迹
  // 保单查询
  getAccountInfo: '/api/v1/ext/policy/query/getAccountInfo',
  getAgentInfo: '/api/v1/ext/policy/query/getAgentInfo', // 获取营销信息
  getTeam: '/api/v1/ext/policy/query/getTeam', // 获取团队信息
  getAgentHistory: '/api/v1/ext/policy/query/getAgentHistory', // 营销历史
  getOptions: '/api/v1/ext/policy/query/getOptions', // 新单操作历史记录
  getNoteInfo: '/api/v1/ext/policy/query/getNoteInfo', // 新单照会信息
  getRecvFirst: '/api/v1/ext/policy/query/getRecvFirstInfo', // 首期扣款记录
  getRecv: '/api/v1/ext/policy/query/getRecvInfo', // 续期记录
  getPolicyBonus: '/api/v1/ext/policy/query/getPolicyBonus', // 红利现金明细
  getSnapshot: '/api/v1/ext/policy/query/getSnapshot', // 现金价值
  getEXPY: '/api/v1/ext/policy/query/getEXPY', // 生存金
  getCallBack: '/api/v1/ext/policy/query/getCallBack', // 回访
  // 其他
  checkPayPromiseBookSign: '/api/v1/ext/agent/other/checkPayPromiseBookSign'
}



// WEBPACK FOOTER //
// ./src/modules/url.js